import request from '../request';

export function index(params) {
  return request({
    url: "/manager/money-management",
    method: "get",
    params
  })
}

export function update(data) {
  return request({
    url: `/manager/money-management/${data.id}`,
    method: "put",
    data
  })
}